import { render } from "./AuthLayout.vue?vue&type=template&id=e0af6396&scoped=true"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=e0af6396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0af6396"]])

export default __exports__